import React, { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";
import ConfirmDeleteDialog from "../../../common/ConfirmDeleteDialog";

const Delete = ({ open, onClose, shellType, onRecordDeleted }) => {
  const { deleteData } = useFirestore("ElearnShellType");

  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setLoading(true);
    setError("");
    try {
      if (!shellType || !shellType.id) {
        throw new Error("Shell Type ID is missing, cannot delete.");
      }
      await deleteData(shellType.id);
      setLoading(false);
      setSnackbarOpen(true);
      onRecordDeleted();
    } catch (error) {
      console.error("Error deleting record:", error);
      setError(error.message || "Error deleting record");
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <ConfirmDeleteDialog
        open={open}
        onClose={onClose}
        onConfirm={handleDelete}
        deleting={loading}
        title="Delete Elearn Shell Type"
        message={
          shellType
            ? `Are you sure you want to delete the following Elearn Shell Type? Name: ${
                shellType.name || "N/A"
              }. This action cannot be undone.`
            : "Are you sure you want to delete this Elearn Shell Type? This action cannot be undone."
        }
      />
      {error && (
        <Snackbar
          open={!!error}
          autoHideDuration={4000}
          onClose={() => setError("")}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={() => setError("")} severity="error" sx={{ width: "100%" }}>
            {error}
          </Alert>
        </Snackbar>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Record deleted successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

export default Delete;
